import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IReduxState } from '../../../ReduxImpl/reducers/index'
import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms'
import { FormFieldSection } from '@sitecore-jss/sitecore-jss-forms'
import { checkConditions } from '../../ConditionalRendering/index'
import { UpdateConditionalSectionControls } from '../../../ReduxImpl/actions'

const SectionFeild: FC<FieldProps<FormFieldSection>> = ({
  field,
  fieldFactory,
}) => {
  const dispatch = useDispatch()

  const stateFieldValues = useSelector(
    (state: IReduxState) => state.fieldValues
  )
  const stateConditions = useSelector((state: IReduxState) => {
    return state.conditions[(field.model['conditionSettings'] as any).fieldKey]
  })

  const showsection = useSelector((state: IReduxState) => state.showsection)

  const IsVisible = (fieldValues, conditions, field) => {
    if (!showsection && field.model.name === 'SectionAll') {
      return true
    } else if (conditions !== undefined && fieldValues !== undefined) {
      let IsSectionHide = checkConditions(fieldValues, conditions)
      dispatch(
        UpdateConditionalSectionControls({
          name: field.model.name,
          IsVisible: !IsSectionHide,
        })
      )
      return IsSectionHide
    } else {
      return false
    }
  }

  return (
    <div
      id={field.model.itemId}
      style={{
        display: !IsVisible(stateFieldValues, stateConditions, field)
          ? 'block'
          : 'none',
      }}
    >
      <fieldset className={field.model.cssClass} style={{ margin: 0 }}>
        {!IsVisible(stateFieldValues, stateConditions, field)
          ? field.fields.map(fieldFactory)
          : null}
      </fieldset>
    </div>
  )
}

export default SectionFeild
